import { jsx } from 'react/jsx-runtime';
import { memo, forwardRef, useCallback } from 'react';
import { Link } from '../Link/Link.esm.js';
import { isSimpleType } from './utils.esm.js';

const SelectableLink = memo(forwardRef(({ variant, linkProps, inverse = false, disabled = false, actionColumn }, ref) => {
    const handleClick = useCallback((e) => {
        e.stopPropagation();
    }, []);
    if (!isSimpleType(variant) || !linkProps) {
        return null;
    }
    return (jsx("div", { className: actionColumn(), onClick: handleClick, children: jsx(Link, Object.assign({}, linkProps, { ref: ref, disabled: disabled, inverse: inverse, tabIndex: -1 })) }));
}));
SelectableLink.displayName = "SelectableLink";

export { SelectableLink };
